import { NextPickInfoSuggestion, NextRoundPlayer } from '@pff-consumer/schema'
import { findIndex, maxBy } from 'lodash'

export const findIndexOfMaxPickGrade = (players: NextPickInfoSuggestion[] | NextRoundPlayer[]) => {
  const maxPickGradePlayer = maxBy(players, 'pickGrade')
  const maxIndex = findIndex(players, maxPickGradePlayer)
  return maxIndex
}
